export default "__VITE_ASSET__49b2544d__"